import React from 'react'

export default class VagasInput extends React.Component {
  render () {
    const tipo  = this.props.tipo;
    const valor = this.props.valor;
    const handleChange = this.props.handleChange;

    return (
      <div>
        <input type="number"
                name={`horarios[][vagas_${tipo}]`}
                className="hora"
                value={valor}
                onChange={handleChange}
                onBlur={this.handleZero}></input>
      </div>
    );
  }
  handleZero (e) {
    if (e.target.value == '')
      e.target.value = '0';
  }

}
